import React, { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  getGradeAll,
  getScoringAlgorithm,
  getStateAll,
  getSubjectAPI,
  updateSubjectAPI,
  postSubjectAPI,
  createSubjectClone,
  getCalculators,
  uploadSubjectIcon,
} from "../../../api/subject.service";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import constant from "../../../utils/constant";
import ManageDomainsAndStandards from "../../shared/common/manageDomainsAndStandards";
import { useForm } from "react-hook-form";
import { IAutoFillData } from "../../../model/interface/autoFillData";
import AddSellableProduct from "../../shared/common/addSellableProduct";
import { ISellableProduct } from "../../../model/interface/sellableProduct";
import AccordionBundles from "../../shared/common/accordionBundles";
import { IBundleList } from "../../../model/interface/bundle";
import { useLocation, useNavigate, Link } from "react-router";
import CloneSubjectModal from "../../shared/common/cloneSubjectModal";
import Loader from "../../shared/loader/loader";
import MultiSelect from "../../shared/common/multiSelect";
import LiftOffsubject from "../liftOffSubject/liftOffsubject";
import {
  Dialog,
  DialogBackdrop,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { toast } from "react-toastify";
import { useNumericParam } from "../../../utils/useNumericParam";

export const SubjectDetails = (props: any) => {
  const defaultValue: any = {};

  const subjectTypes = [
    {
      subjectTypeId: 1,
      name: "Progress Learning",
    },
    {
      subjectTypeId: 2,
      name: "Liftoff",
    },
    {
      subjectTypeId: 3,
      name: "College and Career Readiness",
    },
  ];
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];
  const [contentArea, setContentArea] = useState([]);
  const [states, setStates] = useState([]);
  const [grades, setGrades] = useState([]);
  const [scoringAlgorithms, setScoringAlgorithms] = useState([]);
  const [calculators, setCalculators] = useState([]);
  const [subjectInput, setSubjectInput] = useState(defaultValue);
  const [selectedStates, setSelectedStates] = useState<any>([]);
  const [selectedGrades, setSelectedGrades] = useState<any>([]);
  const [selectedContentArea, setselectedContentArea] = useState(defaultValue);
  const [selectedGradeLevel, setSelectedGradeLevel] = useState(defaultValue);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [autoFillData, setAutoFillData] = useState<IAutoFillData>();
  const [sellableProducts, setSellableProducts] = useState<ISellableProduct[]>(
    []
  );
  const [bundles, setBundles] = useState<IBundleList[]>([]);
  const [lang, setLang] = useState<number>(1);
  const [subjectIcon, setSubjectIcon] = useState<any>();
  let successMessage: string;

  const [selectedScoringAlgorithm, setSelectedScoringAlgorithm] =
    useState(defaultValue);
  const [selectedCalculator, setSelectedCalculator] = useState(defaultValue);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const navigate = useNavigate();
  const id = useNumericParam("id");
  const subjectId = useNumericParam("subjectId");

  const location = useLocation();
  const parameters = location.state as any;
  const [selectedSubjectType, setSelectedSubjectType] = useState<number>(
    parameters?.subjectType
  );
  const [showClonePopup, setShowClonePopup] = useState<boolean>(false);
  const [selectedCloneSubjectId, setselectedCloneSubjectId] =
    useState<number>();
  const [selectedCloneSubjectName, setSelectedCloneSubjectName] =
    useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [allSelectedGrades, setAllSelectedGrades] = useState<Array<any>>([]);
  const [showSubjectTypeModal, setShowSubjectTypeModal] = useState<boolean>(
    id || props.isShowSubjectModal === false ? false : true
  );
  const [reloadIcon, setReloadIcon] = useState<boolean>(true);
  const selectAllOption = {
    value: "<SELECT_ALL>",
    label: "All",
  };

  const submitHandler = async (data) => {
    setIsLoaded(true);
    setLoading(true);

    if (data.name && Object.keys(selectedContentArea).length !== 0) {
      subjectInput.grades = getMappedArray(selectedGrades);
      subjectInput.states = getMappedArray(selectedStates);
      subjectInput.gradeLevel =
        selectedGradeLevel !== null ? selectedGradeLevel.value : "";
      subjectInput.contentAreaId =
        selectedContentArea !== null ? selectedContentArea.value : 0;
      subjectInput.scoringAlgorithm =
        selectedScoringAlgorithm != null
          ? selectedScoringAlgorithm.label
          : null;
      subjectInput.scoringAlgorithmId =
        selectedScoringAlgorithm != null
          ? selectedScoringAlgorithm.value
          : null;
      subjectInput.calculatorTypeId =
        selectedCalculator != null ? selectedCalculator.value : null;
      subjectInput.name = data.name;
      subjectInput.subjectTypeId =
        selectedSubjectType !== null ? selectedSubjectType : "";
      subjectInput.displayName = data.displayName;

      if (data?.spanishDisplayName) {
        subjectInput.spanishDisplayName = data.spanishDisplayName;
      }

      let subjectId = 0;
      if (id) {
        subjectId = id;
        await updateSubjectAPI(subjectInput);
        successMessage = "Subject Updated Successfully";
      } else {
        const data = await postSubjectAPI(subjectInput);
        successMessage = `Subject Added Successfully, ID- ${data.data}`;
        subjectId = data.data;
      }
      if (subjectIcon != null) {
        //upload icon
        setReloadIcon(false);
        const formData = new FormData();
        formData.append("subjectId", subjectId.toString());
        formData.append("subjectFile", subjectIcon);
        formData.append("name", subjectInput.name);
        formData.append("subjectIcon", subjectInput.subjectIcon);

        try {
          await uploadSubjectIcon(formData).then((res) => {
            subjectInput.subjectIcon = res.data;
            setReloadIcon(true);
          });
        } catch (_) {
          toast.error("Couldn't upload icon");
        }
      }
      if (id !== subjectId) {
        navigate(constant.SUBJECTDETAIL.replace(":id", subjectId.toString()), {
          state: { subjectType: selectedSubjectType },
        });
      }
      setLoading(false);

      toast.success(successMessage);
    }
  };

  function handleAddProductConfimation(confirmAction: boolean) {
    setShowConfirmation(false);
    if (id) {
      updateSubjectProductData(id);
    }
  }

  function getMappedArray(arr: any[]): any[] {
    if (arr === null || arr.length === 0) {
      return [];
    } else {
      return arr.reduce((acc: any, cur: any) => {
        if (Number(cur.value)) acc.push({ id: cur.value, name: cur.label });
        return acc;
      }, []);
    }
  }

  async function inputChangeHandler(e: any) {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    if (name === "icon" && e?.target?.files?.length) {
      setSubjectIcon(e.target.files[0]);
    } else {
      setSubjectInput({
        ...subjectInput,
        [name]:
          e.target.id === "isApproved"
            ? e.target.id === "isApproved"
              ? !subjectInput.isApproved
              : value
            : e.target.id === "isDeprecated"
            ? !subjectInput.isDeprecated
            : e.target.id === "isActive"
            ? !subjectInput.isActive
            : value,
      });
    }
  }

  useEffect(() => {
    if (id === 0) {
      navigate(constant.BAD_REQUEST, { replace: true });
    }
    getContent();
    getGrades();
    getStates();
    getScoringAlgorithmData();
    getCalculatorsData();
    if (id) getSubject(id);
  }, [id]);

  const updateSubjectProductData = async (id: number) => {
    setLoading(true);
    const response = getSubjectAPI(id);
    const subject = (await response).data;
    setLoading(false);

    setSellableProducts(subject.sellableProducts);
  };

  const getSubject = async (id: number) => {
    setLoading(true);
    const response = getSubjectAPI(id);
    const subject = (await response).data;
    setSelectedSubjectType(Number(subject.subjectTypeId));
    setLoading(false);

    setSellableProducts(subject.sellableProducts);
    setBundles(subject.bundles);

    const subjectAutoFill = {
      contentId: subject.contentAreaId,
      subjectId: subject.subjectId,
      domainId: 0,
    };
    setAutoFillData(subjectAutoFill);

    setSubjectInput(subject);

    setselectedContentArea({
      label: subject.contentAreaName,
      value: subject.contentAreaId,
    });

    if (subject.states !== null && subject.states.length > 0) {
      const filteredStates = subject.states.reduce((acc: any, cur: any) => {
        acc.push({ label: cur.name, value: cur.id });
        return acc;
      }, []);
      setSelectedStates(filteredStates);
    }

    if (subject.grades !== null && subject.grades.length > 0) {
      const filteredGrades = subject.grades.reduce((acc: any, cur: any) => {
        acc.push({ label: cur.name, value: cur.id });
        return acc;
      }, []);
      setSelectedGrades(filteredGrades);
    }

    const gradeLevel = gradeLevelData.find((t) => {
      return t.value === subject.gradeLevel?.trim();
    });
    setSelectedGradeLevel(gradeLevel);

    setSelectedScoringAlgorithm({
      label: subject.scoringAlgorithm,
      value: subject.scoringAlgorithmId,
    });

    setSelectedCalculator({
      label: subject.calculatorTypeName,
      value: subject.calculatorTypeId,
    });
  };

  const getScoringAlgorithmData = async () => {
    const response = getScoringAlgorithm();
    const data = (await response).data;
    let dropdownData = [];
    if (data.length > 0) {
      dropdownData = data.map((algo) => {
        return {
          value: algo.scoringAlgorithmId || 0,
          label: `${algo.name}`,
        };
      });
    }
    setScoringAlgorithms(dropdownData);
  };

  const getCalculatorsData = async () => {
    const response = getCalculators();
    const data = (await response).data;
    let dropdownData = [];
    if (data.length > 0) {
      dropdownData = data.map((calculator) => {
        return {
          value: calculator.calculatorTypeId || 0,
          label: `${calculator.name}`,
        };
      });
    }
    if (dropdownData.length > 0) {
      const defaultItem = dropdownData.filter((item: any) => {
        return (item.calculatorTypeId = 1);
      });
      setSelectedCalculator(defaultItem[0]);
    }
    setCalculators(dropdownData);
  };

  const getStates = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setStates(newStateData);
  };

  const getContent = async () => {
    const service = await import("../../../api/contentArea.service");
    const response = service.getContentArea(999, 1);
    const data = (await response).data;
    let dropdownData = [];
    if (data.data.length > 0) {
      dropdownData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContentArea(dropdownData);
  };

  const getGrades = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let dropdownData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      dropdownData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrades(dropdownData);
  };

  const breadcrumbItems = () => {
    const subjectType = subjectTypes.find(
      (t) => t.subjectTypeId === selectedSubjectType
    );

    const items: Array<IBreadcrumb> = [
      { name: "Subject", url: constant.SUBJECTS },
      {
        name: subjectType?.name ?? "",
        url: "",
      },
      {
        name: id ? `Edit Subject` : "Add Subject",
        url: "",
      },
    ];

    if (subjectId && id) {
      items.push({ name: id?.toString(), url: "" });
    }

    return items;
  };

  const handleDropdownChange = (e: Event, type: string) => {
    setIsLoaded(true);
    switch (type) {
      case "State":
        setSelectedStates(e);
        break;
      case "GradeLevel":
        setSelectedGradeLevel(e);
        break;
      case "ContentArea":
        setselectedContentArea(e);
        break;
      case "ScoringAlgorithm":
        setSelectedScoringAlgorithm(e);
        break;
      case "Calculator":
        setSelectedCalculator(e);
        break;
    }
  };

  function redirectToProductDetail(productId: number) {
    if (productId) {
      navigate(
        constant.MANAGESELLABLEPRODUCT.replace(":id", productId.toString())
      );
    }
  }

  function redirectToBundleDetail(bundleId: number) {
    if (bundleId) {
      navigate(constant.EDITBUNDLES.replace(":id", bundleId.toString()));
    }
  }

  const toggleLang = () => {
    if (lang === 1) {
      setLang(2);
    } else {
      setLang(1);
    }
  };

  const handleAddBundle = () => {
    navigate(constant.ADDBUNDLES, {
      state: { subjectId: subjectId },
    });
  };

  function redirectToSubjectDetail(subjectId: number, subjectType: number) {
    if (subjectType === constant.SubjectType.LO) {
      navigate(
        constant.LIFTOFFSUBJECTEDIT.replace(":id", subjectId.toString())
      );
    } else if (subjectId) {
      navigate(constant.SUBJECTDETAIL.replace(":id", subjectId.toString()));
    } else {
      navigate(constant.ADDSUBJECT);
    }
  }
  function redirectToSubjectClone(subjectId: number) {
    if (subjectId) {
      navigate(constant.SUBJECTDETAIL.replace(":id", subjectId.toString()));
    }
  }

  function closeClonePopup() {
    setShowClonePopup(false);
  }

  function handleCloneSubject(subjectId: number, subjectName: string) {
    setselectedCloneSubjectId(subjectId);
    setSelectedCloneSubjectName(subjectName);
    setShowClonePopup(true);
  }
  function cloneSubject(subjectId: number) {
    setShowClonePopup(false);
    createSubjectClone(subjectId).then((clonedSubject) => {
      redirectToSubjectClone(clonedSubject.data);
    });
  }

  const isSelectAllGradesSelected = () =>
    selectedGrades?.length === grades?.length;

  const isOptionSelected = (option: any) =>
    selectedGrades.some(({ value }: any) => value === option.value) ||
    isSelectAllGradesSelected();

  const onGradeChange = (newValue: any, actionMeta: any) => {
    const { action, option, removedValue } = actionMeta;

    if (action === "select-option" && option.value === selectAllOption.value) {
      setSelectedGrades(grades);
      setAllSelectedGrades(grades);
    } else if (
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)
    ) {
      setSelectedGrades([]);
    } else if (
      actionMeta.action === "deselect-option" &&
      isSelectAllGradesSelected()
    ) {
      setSelectedGrades(
        grades.filter(({ value }: any) => value !== option.value)
      );
    } else if (action === "remove-value" && removedValue.value) {
      let ds: Array<any> = [];
      if (allSelectedGrades.length) {
        ds = allSelectedGrades.filter(
          ({ value }: any) => value !== removedValue.value
        );
      } else {
        ds = grades.filter(({ value }: any) => value !== removedValue.value);
      }
      setSelectedGrades(ds);
      setAllSelectedGrades(ds);
    } else {
      setSelectedGrades(newValue || []);
    }
  };

  function handleRedirection(name: string, id: number) {
    if (name && id) {
      navigate(`/${name}/edit/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }

  const onSubjectTypeChange = (type) => {
    setSelectedSubjectType(type);
    setShowSubjectTypeModal(false);
  };

  return (
    <AllowedTo
      perform={[Permissions.subject_create, Permissions.subject_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showClonePopup && (
        <CloneSubjectModal
          closeCloneModal={closeClonePopup}
          cloneSubject={cloneSubject}
          subjectName={selectedCloneSubjectName}
          subjectId={selectedCloneSubjectId}
        />
      )}

      {showConfirmation && (
        <AddSellableProduct
          subjectId={id}
          subjectName={subjectInput.name}
          existingSellableProducts={sellableProducts}
          title={"Add Sellable Product"}
          confirmAction={handleAddProductConfimation}
          buttonText={"Add"}
        />
      )}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8 py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between pb-2">
              <h3 className="text-lg font-light text-gray-900">Subject</h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />

            <Fragment>
              {[1, 3].includes(selectedSubjectType) && (
                <div className="flex">
                  <form
                    className="w-2/5 mr-14"
                    onSubmit={handleSubmit(submitHandler)}
                  >
                    <div className="shadow py-6 border rounded-lg mt-4 px-6">
                      <div className="flex justify-end">
                        <div
                          className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4"
                          onClick={() => toggleLang()}
                        >
                          <span
                            className={`${
                              lang === 1
                                ? "bg-primary-color text-white"
                                : "bg-white text-gray-400"
                            } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                          >
                            English
                          </span>
                          <span
                            className={`${
                              lang === 2
                                ? "bg-primary-color text-white"
                                : "bg-white text-gray-400"
                            } w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                          >
                            Spanish
                          </span>
                        </div>
                      </div>

                      {id && (
                        <div className="sm:col-span-2 mb-4">
                          <AccordionBundles
                            bundles={bundles}
                            sellableProducts={sellableProducts}
                            addProductAction={setShowConfirmation}
                            addBundleAction={handleAddBundle}
                            productRedirectAction={redirectToProductDetail}
                            bundleRedirectAction={redirectToBundleDetail}
                          />
                        </div>
                      )}

                      <div className="grid grid-cols-1 mt-2">
                        <div>
                          <label
                            className={`${
                              lang === 1 ? "" : "hidden"
                            } text-sm font-medium text-gray-700`}
                          >
                            Name
                          </label>

                          <div>
                            <input
                              id="name"
                              defaultValue={subjectInput.name}
                              autoComplete="off"
                              type="text"
                              className={`${
                                lang === 1 ? "" : "hidden"
                              } block border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm w-full`}
                              {...register("name", {
                                required: true,
                                value: subjectInput.name,
                              })}
                              name="name"
                              onChange={inputChangeHandler}
                            />

                            {lang === 1 &&
                              errors.name &&
                              errors.name.type == "required" && (
                                <span className="text-red-700 inline-block pt-1 text-sm">
                                  Name is required
                                </span>
                              )}
                          </div>
                        </div>
                      </div>

                      <div
                        className={`grid grid-cols-1 ${
                          lang === 1 ? "mt-5" : "mt-2"
                        }`}
                      >
                        <div>
                          <label className="text-sm font-medium text-gray-700">
                            Display Name
                          </label>

                          <div>
                            <input
                              id="displayName"
                              defaultValue={subjectInput.displayName}
                              autoComplete="off"
                              type="text"
                              className={`${
                                lang === 1 ? "" : "hidden"
                              } block border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm w-full`}
                              {...register("displayName", {
                                required: true,
                                value: subjectInput.displayName,
                              })}
                              name="displayName"
                              onChange={inputChangeHandler}
                            />

                            <input
                              id="spanishDisplayName"
                              defaultValue={subjectInput.spanishDisplayName}
                              autoComplete="off"
                              type="text"
                              className={`${
                                lang === 2 ? "" : "hidden"
                              } block border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color  sm:text-sm w-full`}
                              {...register("spanishDisplayName")}
                            />

                            {lang === 1 &&
                              errors.displayName &&
                              errors.displayName.type == "required" && (
                                <span className="text-red-700 inline-block pt-1 text-sm">
                                  Display name is required
                                </span>
                              )}
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center col-span-1">
                          <label className="font-medium text-gray-700">
                            Scoring Algorithm
                          </label>
                        </div>
                        <div
                          id="scoringAlgorithm"
                          className="mt-1 block w-full focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        >
                          <Select
                            options={scoringAlgorithms}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            value={selectedScoringAlgorithm}
                            onChange={(e) => {
                              handleDropdownChange(e, "ScoringAlgorithm");
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          ></Select>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center col-span-1">
                          {selectedContentArea?.value ? (
                            <a
                              className="text-gray-700 text-sm underline"
                              onClick={() =>
                                handleRedirection(
                                  "content-areas",
                                  parseInt(selectedContentArea?.value)
                                )
                              }
                              href={`/content-areas/edit/${parseInt(
                                selectedContentArea?.value
                              )}`}
                            >
                              Content Area
                            </a>
                          ) : (
                            <button className="text-gray-700 text-sm cursor-default">
                              Content Area
                            </button>
                          )}
                        </div>
                        <div
                          id="contentAreaFilter"
                          className="block mt-1 w-full col-span-3 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        >
                          <Select
                            name="contentArea"
                            value={selectedContentArea}
                            options={contentArea}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            onChange={(e) => {
                              handleDropdownChange(e, "ContentArea");
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          />
                          {isLoaded &&
                            Object.keys(selectedContentArea).length === 0 && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Content area is required.
                              </span>
                            )}
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center col-span-1">
                          <label className="font-medium text-gray-700">
                            Grade Level
                          </label>
                        </div>
                        <div
                          id="gradeLevelFilter"
                          className="block mt-1 w-full col-span-3 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        >
                          <Select
                            options={gradeLevelData}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            value={selectedGradeLevel}
                            onChange={(e) => {
                              handleDropdownChange(e, "GradeLevel");
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          ></Select>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center">
                          <label className="font-medium text-gray-700">
                            Grade
                          </label>
                        </div>
                        <div
                          id="grades"
                          className="block w-full mt-1 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        >
                          <MultiSelect
                            options={grades}
                            selectedItems={selectedGrades}
                            setSelectedItems={setSelectedGrades}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center">
                          <label className="font-medium text-gray-700">
                            State
                          </label>
                        </div>
                        <div
                          id="states"
                          className="block w-full mt-1 col-span-3 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        >
                          <MultiSelect
                            options={states}
                            selectedItems={selectedStates}
                            setSelectedItems={setSelectedStates}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center col-span-1">
                          <label className="font-medium text-gray-700">
                            Calculator
                          </label>
                        </div>
                        <div
                          id="calculator"
                          className="mt-1 block w-full focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        >
                          <Select
                            options={calculators}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            value={selectedCalculator}
                            onChange={(e) => {
                              handleDropdownChange(e, "Calculator");
                            }}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          ></Select>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center">
                          <label className="font-medium text-gray-700">
                            Notes
                          </label>
                        </div>
                        <div>
                          <textarea
                            id="notes"
                            name="notes"
                            onChange={inputChangeHandler}
                            style={{
                              height: "100px",
                            }}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            defaultValue={subjectInput.notes}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center">
                          <label className="font-medium text-gray-700">
                            Upload Icon
                          </label>
                        </div>
                        <div className="flex items-center">
                          <input
                            type="file"
                            id="icon"
                            name="icon"
                            onChange={inputChangeHandler}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          />
                          {subjectInput?.subjectIcon && (
                            <img
                              title={props.title}
                              className="icon ml-2 h-10"
                              src={subjectInput?.subjectIcon}
                              alt="Image not found"
                            />
                          )}
                        </div>
                      </div>

                      {subjectInput.clonedFrom?.subjectName ? (
                        <div className="flex justify-between space-x-4 mt-5">
                          <div className="px-3 py-3 shadow-lg border rounded-lg w-full dark:text-white">
                            <div className="flex justify-between">
                              <div className="flex w-full justify-between items-center mt-1 mb-4 rounded-lg">
                                Cloned from
                              </div>
                            </div>

                            <div
                              key={"1"}
                              className={`flex py-3 px-3 mb-2  rounded-lg bg-white border`}
                            >
                              <div className="w-full">
                                <div
                                  id="bundleList"
                                  className="max-h-36 overflow-y-scroll"
                                >
                                  <div className="flex items-center border-b pb-2 mb-2 border-gray-200">
                                    <div className="flex items-center">
                                      <span
                                        className="ml-2 cursor-pointer font-medium  hover:underline"
                                        onClick={(e) => {
                                          redirectToSubjectDetail(
                                            subjectInput.clonedFrom.subjectId,
                                            parseInt(subjectInput.subjectTypeId)
                                          );
                                        }}
                                      >
                                        {`[${subjectInput.clonedFrom.subjectId}] ${subjectInput.clonedFrom.subjectName}`}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {subjectInput.clonedSubjects?.length > 0 && (
                        <div className="flex justify-between space-x-4 mt-5">
                          <div className="px-3 py-3 shadow-lg border rounded-lg w-full dark:text-white">
                            <div className="flex justify-between">
                              <div className="flex w-full justify-between items-center mt-1 mb-4 rounded-lg">
                                Cloned To
                              </div>
                            </div>

                            <div
                              key={"1"}
                              className={`flex py-3 px-3 mb-2  rounded-lg bg-white border`}
                            >
                              <div className="w-full">
                                <div
                                  id="bundleList"
                                  className="max-h-36 overflow-y-scroll"
                                >
                                  {subjectInput.clonedSubjects.map((clone) => (
                                    <div
                                      key={clone.subjectId}
                                      className="flex items-center border-b pb-2 mb-2 border-gray-200"
                                    >
                                      <div className="flex items-center">
                                        <span
                                          className="ml-2 cursor-pointer font-medium  hover:underline"
                                          onClick={(e) => {
                                            redirectToSubjectDetail(
                                              clone.subjectId,
                                              parseInt(
                                                subjectInput.subjectTypeId
                                              )
                                            );
                                          }}
                                        >
                                          {`[${clone.subjectId}] ${clone.subjectName}`}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className=" flex mt-5">
                        <div>
                          <input
                            id="isApproved"
                            name="isApproved"
                            type="checkbox"
                            checked={subjectInput.isApproved}
                            onChange={inputChangeHandler}
                            className=" h-4 w-4 mr-2 focus:ring-primary-color text-primary-color  border-gray-300 sm:text-sm border-gray-300 rounded"
                          />
                        </div>
                        <div className="text-sm flex items-center">
                          <label className="font-medium text-gray-700">
                            Approved
                          </label>
                        </div>
                        {id && (
                          <>
                            <div className="ml-6">
                              <input
                                id="isDeprecated"
                                name="isDeprecated"
                                type="checkbox"
                                checked={subjectInput.isDeprecated}
                                onChange={inputChangeHandler}
                                className=" h-4 w-4 mr-2 focus:ring-primary-color text-primary-color  border-gray-300 sm:text-sm border-gray-300 rounded"
                              />
                            </div>
                            <div className="text-sm flex items-center">
                              <label className="font-medium text-gray-700">
                                Deprecated
                              </label>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="flex justify-between pb-2 border-t mt-5 items-center">
                        {id && (
                          <button
                            type="submit"
                            onClick={(e) => {
                              handleCloneSubject(
                                subjectInput.subjectId,
                                subjectInput.name
                              );
                            }}
                            className=" cursor-pointer inline-flex items-center px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-secondary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                          >
                            Clone
                          </button>
                        )}

                        <div>
                          <button
                            type="submit"
                            className=" cursor-pointer inline-flex items-center px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                          >
                            {id && !parameters?.subjectToCopy
                              ? "Update"
                              : parameters?.subjectToCopy
                              ? "Clone"
                              : "Save"}
                          </button>
                          <Link to={constant.SUBJECTS} className="ml-2">
                            <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                              Cancel
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>

                  {id && (
                    <ManageDomainsAndStandards
                      showTestPercent={true}
                      subjectId={id}
                      autoFillData={autoFillData}
                      showTestPercentAlert={
                        subjectInput.totalTestPercentage == 100 ? false : true
                      }
                    />
                  )}
                </div>
              )}

              {selectedSubjectType === 2 && <LiftOffsubject {...props} />}

              {showSubjectTypeModal && (
                <div>
                  <Transition.Root show={true} as={Fragment}>
                    <Dialog
                      as="div"
                      className="fixed z-10 inset-0"
                      onClose={() => navigate("/subjects")}
                    >
                      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <TransitionChild
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </TransitionChild>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                          className="hidden sm:inline-block sm:align-middle sm:h-screen"
                          aria-hidden="true"
                        >
                          &#8203;
                        </span>
                        <TransitionChild
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                          enterTo="opacity-100 translate-y-0 sm:scale-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                          <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 w-1/4">
                            <form>
                              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                                <button
                                  type="button"
                                  className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none "
                                  onClick={() => navigate("/subjects")}
                                >
                                  <span className="sr-only">Close</span>
                                  <XIcon
                                    className="h-6 w-6"
                                    aria-hidden="true"
                                  />
                                </button>
                              </div>
                              <div className="sm:flex sm:items-start">
                                <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
                                  <DialogTitle
                                    as="h3"
                                    className="text-sm text-gray-700"
                                  >
                                    Subject Type
                                  </DialogTitle>

                                  <div className="grid grid-cols-1 divide-y divide-gray-300 border border-gray-300 rounded-lg ">
                                    {subjectTypes.map((subjectType, index) => (
                                      <div
                                        className=" bg-gray-100 h-22 px-4 py-4 flex"
                                        key={index}
                                      >
                                        <div className="flex items-center w-full">
                                          <input
                                            id={`radio${index}`}
                                            type="radio"
                                            className=" h-4 w-4 "
                                            onChange={() =>
                                              onSubjectTypeChange(
                                                subjectType.subjectTypeId
                                              )
                                            }
                                            checked={
                                              selectedSubjectType ===
                                              subjectType.subjectTypeId
                                            }
                                          />
                                          <label className="focus:ring-primary-color dark:text-white text-primary-color border-gray-300 ml-2">
                                            {subjectType.name} Subject
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </TransitionChild>
                      </div>
                    </Dialog>
                  </Transition.Root>
                </div>
              )}
            </Fragment>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(SubjectDetails);
